import React from "react";
import svg2 from "../../assets/svg/svg2.svg";
import svg3 from "../../assets/svg/svg3.svg";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setVerifiedActive } from "../../features/global/globalSlice";

const items = [
  {
    title: "Farmers",
    total: "75,500",
    percentage: "-11%",
    svg: "svg2",
    bgColor: "#B1E17C",
    link: "/farmers-list",
  },
  {
    title: "Expressed Interest",
    total: "1",
    percentage: "+8%",
    svg: "svg3",
    bgColor: "#E1D77C",
    link: "/expression-of-interest",
  },
  {
    title: "Verified",
    total: "0",
    percentage: "-11%",
    svg: "svg2",
    bgColor: "#B1E17C",
    link: "/verified-expression-list",
  },
  {
    title: "Installed",
    total: "0",
    percentage: "+8%",
    svg: "svg3",
    bgColor: "#D9B382",
    link: "/verified-expression-list",
  },
  {
    title: "MISPS",
    total: "0",
    percentage: "+8%",
    svg: "svg2",
    bgColor: "#E9D1FF",
  },
];
function CardDash() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const svgMap = {
    svg2,
    svg3,
  };
  const processedData = items?.map((item) => ({
    ...item,
    svg: svgMap[item?.svg],
  }));

  const handleNavigation = async (item) => {
    await navigate(item?.link ?? null);
    if(item?.title === 'Verified'){
      await dispatch(setVerifiedActive("1"));
    }
    if(item?.title === 'Installed'){
      await dispatch(setVerifiedActive("1"));
    }
    
  };
  return (
    <div className=" flex flex-shrink flex-wrap w-full gap-y-[1rem] gap-x-[1rem]">
      {processedData &&
        processedData?.map((item) => (
          <div
            onClick={() => handleNavigation(item)}
            key={item?.total}
            style={{
              borderRadius: "0.75rem",
              background: item?.bgColor,
              boxShadow: "0px 4px 20px 0px rgba(7, 6, 18, 0.10)",
            }}
            className="p-[1.25rem]  lg:w-[280px] w-full cursor-pointer"
          >
            <div className="dash-card-h1">{item?.title}</div>
            <div className=" dash-card-h1 flex items-center justify-between !text-[2.125rem] !leading-[2.25rem] mt-[1.62rem]">
              {item?.total}

              <div className="flex items-center gap-x-[.25rem]">
                <img src={item?.svg} alt="icon" />
                <span className="">{item?.percentage}</span>
              </div>
            </div>
          </div>
        ))}
    </div>
  );
}

export default CardDash;
